import { ErrorBoundary } from 'react-error-boundary';
import { DefaultErrorBoundaryProps } from './DefaultErrorBoudary.types';
import { ErrorComponent } from '../../ErrorComponent';
import { UpdateErrorBoundary } from './components';

export const DefaultErrorBoundary = ({ children }: DefaultErrorBoundaryProps) => (
  <ErrorBoundary
    fallbackRender={({ error }) => {
      if (error.message.includes('Failed to fetch dynamically imported module')) {
        return <UpdateErrorBoundary />;
      }

      return <ErrorComponent error={error} />;
    }}
  >
    {children}
  </ErrorBoundary>
);
